
import { defineComponent, PropType } from 'vue'

// @types
import { TimeSlotZone } from '@/new-services/types/time-slot-zones'

export default defineComponent({
    name: 'time-slot-zone-list-item',
    props: {
        item: {
            type: Object as PropType<TimeSlotZone>,
            required: true
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        isCanUpdate: {
            type: Boolean,
            default: false,
        },
        isCanDelete: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['delete', 'update', 'view'],
    setup(props, { emit }) {
        const onDelete = () => {
            if (props.disabled) return
            emit('delete', { ...props.item })
        }
        
        const onUpdate = () => {
            if (props.disabled) return
            emit('update', { ...props.item })
        }

        const onView = () => {
            if (props.disabled) return
            emit('view', { ...props.item })
        }

        return {
            onDelete,
            onUpdate,
            onView,
        }
    }
})
